export const validateForm = (formRef) => {
    return new Promise((resolve, reject) => {
        formRef.validate().then(result => result ? resolve(result):reject(result))
    })
}
